var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99087 1.3335C4.93087 1.3335 0.833374 5.44016 0.833374 10.5002C0.833374 15.5602 4.93087 19.6668 9.99087 19.6668C15.06 19.6668 19.1667 15.5602 19.1667 10.5002C19.1667 5.44016 15.06 1.3335 9.99087 1.3335ZM10 17.8335C5.94837 17.8335 2.66671 14.5518 2.66671 10.5002C2.66671 6.4485 5.94837 3.16683 10 3.16683C14.0517 3.16683 17.3334 6.4485 17.3334 10.5002C17.3334 14.5518 14.0517 17.8335 10 17.8335ZM10.4584 5.91683H9.08337V11.4168L13.8959 14.3043L14.5834 13.1768L10.4584 10.7293V5.91683Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLine);
export default __webpack_public_path__ + "static/media/time-line.4ced6c62a7a4d6789bc4ebad24946863.svg";
export { ForwardRef as ReactComponent };